import React from 'react';
import macLogo from '../styles/img/logo.png';

/**
 * Footer del sitio — reemplaza al footer oscuro anterior, que dependía de
 * una imagen externa (https://hospitalesmac.com/img/logo_blanco.png) cuya
 * ruta ya no existe en el sitio actual de Hospitales MAC (reestructuraron
 * sus assets bajo /uploads/es/images/...). Este usa el logo local del
 * proyecto (ya disponible en src/styles/img/logo.png) y no depende de
 * ningún recurso externo, evitando el riesgo de íconos/imágenes rotas.
 */
const AppFooter = () => (
  <footer style={{
    alignItems: 'center', background: 'var(--surface-alt)', borderTop: '1px solid var(--border-secondary)',
    display: 'flex', flexWrap: 'wrap', gap: '14px 24px', justifyContent: 'space-between',
    padding: '18px 24px',
  }}>
    {/* Marca */}
    <div style={{ alignItems: 'center', display: 'flex', gap: '10px' }}>
      <img src={macLogo} alt="Hospitales MAC" style={{ height: '26px', width: 'auto' }} />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ color: '#039490', fontSize: '12px', fontWeight: 700 }}>Hospitales MAC</span>
        <span style={{ color: 'var(--text-tertiary)', fontSize: '10.5px' }}>Agenda de quirófano</span>
      </div>
    </div>

    {/* Links */}
    <div style={{ alignItems: 'center', display: 'flex', gap: '8px' }}>
      <a href="https://hospitalesmac.com/aviso-de-privacidad" target="_blank" rel="noreferrer"
         style={{ color: 'var(--text-secondary)', fontSize: '12px', textDecoration: 'none' }}>
        Aviso de Privacidad
      </a>
      <span style={{ color: 'var(--border-primary)', fontSize: '12px' }}>·</span>
      <a href="https://hospitalesmac.com" target="_blank" rel="noreferrer"
         style={{ color: 'var(--text-secondary)', fontSize: '12px', textDecoration: 'none' }}>
        hospitalesmac.com
      </a>
    </div>

    {/* Contacto */}
    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
      <span style={{ color: 'var(--text-secondary)', fontSize: '11.5px' }}>contacto@hospitalesmac.com</span>
      <span style={{ color: 'var(--text-tertiary)', fontSize: '10.5px' }}>© {new Date().getFullYear()} Derechos reservados</span>
    </div>
  </footer>
);

export default AppFooter;
